import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIHoverActionController } from './UIHoverActionController.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { MechanicValidatorSettlement } from '@colonist/game-mechanic-validators';
export class UISettlementHoverActionController extends UIHoverActionController {
    getBankActionAmount(index) {
        const settlementPlayerState = this.settlementValidator.getSettlementPlayerState(this.uiGameManager.gameController.myColor);
        return settlementPlayerState.bankSettlementAmount;
    }
    updateState() {
        const useResources = true;
        const canPlaceSettlement = this.settlementValidator.canPlayerPlaceSettlement(this.uiGameManager.gameController.myColor, useResources);
        this.updateHoverLocations(canPlaceSettlement.validHoverLocations, canPlaceSettlement.canTakeAction);
        this.uiGameManager.mapController.hoverController.onHoverStateChange();
    }
    getTexture(index) {
        return UIGameSpriteHandler.getSettlementForPlayer(this.uiGameManager.gameController.myColor);
    }
    constructor(uiGameManager, settlementState){
        super(uiGameManager);
        this.isCornerAction = true;
        this.resources = getCardsForPiece(PieceTypes.Settlement);
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmBuildSettlementSkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this);
        this.settlementValidator = new MechanicValidatorSettlement(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.uiGameManager.gameController.currentStateValidator, settlementState);
    }
}
